(() => {
  const THRESHOLD = 10; // px from top
  const setClass = () => {
    const atTop = window.scrollY <= THRESHOLD;
    document.body.classList.toggle("is-at-top", atTop);
  };

  window.addEventListener("scroll", setClass, { passive: true });
  window.addEventListener("load", setClass);
  setClass();
})();
